export const friendlyMessage = (message: string) => {
	switch (message) {
		case 'PASSWORD parameter is required':
			return { message: 'Please enter your password to log in.', action: null };
		case 'Missing required parameter USERNAME':
			return { message: 'Please enter your username to log in.', action: null };
		case 'User does not exist.':
			return { message: 'Email address not recognised, please try again.', action: null };
		case 'Incorrect username or password.':
			return { message: 'The password you provided did not match your username, please try again.', action: null };
		case 'User is not confirmed.':
			return { message: 'Your account has not yet been verified, please check your email for a verification link.', action: null };
		case 'Password reset required for the user':
			return { message: 'Please choose a new password.', action: 'reset' };
		case 'Password reset required for user due to security reasons':
			return { message: 'Your password is potentially insecure, please choose a new password.', action: 'reset' };
		default:
			return { message: 'There was a problem logging you in. Contact support for help.', action: null };
	}
};
